import { CardActions } from "@material-ui/core";
import { SET_BALANCE, SET_EXPOSURE, SET_GAME, SET_MATCH } from "./types";

const initialState = { exposure: 0, balance: 0, matchs: {} };

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_EXPOSURE:
      return {
        ...state,
        exposure: action.payload,
      };
    case SET_BALANCE: {
      return { ...state, balance: action.payload };
    }
    case SET_MATCH: {
      return {
        ...state,
        matchs: {
          ...state.matchs,
          [action.payload.matchId]: action.payload.match,
        },
      };
    }
    case SET_GAME: {
      return {
        ...state,
        games: {
          ...state.games,
          [action.payload.type]: action.payload.games,
        },
      };
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducer.js